import { SET_SELECTED_GPT_MODAL, SET_SELECTED_AGENT, SET_RBAC_DATA, SET_WEB_SEARCH_ENABLED, SET_FILE_UPLOADED, SET_NPS_POPUP_VISIBILITY, SET_SIDEBAR_COLLAPSED, SET_THINKING_ENABLED, SET_SELECTED_THREAD_NAME, SET_CATEGORY_PROMPTS, SET_SELECTED_TOOL, SET_SELECTED_LANGUAGE, SET_TALENT_PULSE_WEB_SEARCH_ENABLED } from "./actionTypes";

let savedThread = null;
try {
    const threadString = localStorage.getItem("selectedThreadName");
    savedThread = threadString ? JSON.parse(threadString) : null;
} catch (e) {
    console.warn("Failed to parse selected thread from storage", e);
    savedThread = null;
}

const initialState = {
    selectedModal: null, // Default value for selected modal
    selectedAgent: null, // Default value for selected agent
    rbacData: null, // All RBAC data from API
    webSearchEnabled: false, // Web search toggle state
    talentPulseWebSearchEnabled: false, // Talent pulse specific web search toggle state
    isFileUploaded: false, // File upload state
    showNpsPopup: false, // NPS popup visibility
    sidebarCollapsed: true, // Default sidebar state
    thinkingEnabled: false, // Thinking/reasoning mode toggle
    selectedThreadName: savedThread, // Object containing all details of the selected chat thread
    selectedTool: null, // Stores the name of the selected tool
    selectedLanguage: "English", // Default selected language
    categoryPrompts: {
        personal: [],
        suggested: [],
        all: [],
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECTED_GPT_MODAL:
            return {
                ...state,
                selectedModal: action.payload,
            };
        case SET_SELECTED_AGENT:
            return {
                ...state,
                selectedAgent: action.payload,
            };
        case SET_RBAC_DATA:
            return {
                ...state,
                rbacData: action.payload,
            };
        case SET_WEB_SEARCH_ENABLED:
            return {
                ...state,
                webSearchEnabled: action.payload,
            };
        case SET_TALENT_PULSE_WEB_SEARCH_ENABLED:
            return {
                ...state,
                talentPulseWebSearchEnabled: action.payload,
            };
        case SET_FILE_UPLOADED:
            return {
                ...state,
                isFileUploaded: action.payload,
            };
        case SET_NPS_POPUP_VISIBILITY:
            return {
                ...state,
                showNpsPopup: action.payload,
            };
        case SET_SIDEBAR_COLLAPSED:
            return {
                ...state,
                sidebarCollapsed: action.payload,
            };
        case SET_THINKING_ENABLED:
            return {
                ...state,
                thinkingEnabled: action.payload,
            };
        case SET_SELECTED_THREAD_NAME:
            return {
                ...state,
                selectedThreadName: action.payload,
            };
        case SET_SELECTED_TOOL:
            return {
                ...state,
                selectedTool: action.payload,
            };
        case SET_SELECTED_LANGUAGE:
            return {
                ...state,
                selectedLanguage: action.payload,
            };
        case SET_CATEGORY_PROMPTS:
            return {
                ...state,
                categoryPrompts: {
                    ...state.categoryPrompts,
                    [action.payload.type]: action.payload.data,
                },
            };
        default:
            return state;
    }
};

export default reducer;